<template>
	<div
		ref="containerRef"
		:class="[
			'rounded-2xl border border-slate-100 bg-white w-full xl:max-w-md relative  scrollbar-hide',
			{
				'max-h-[360px] overflow-hidden': !showAll,
				'max-h-[560px] overflow-auto': showAll
			}
		]"
	>
		<div class="p-4 pb-0 flex flex-col gap-4 sticky top-0 bg-white">
			<Subtitle
				weight="medium"
				size="small"
				tag="h3"
				class="title-font"
			>
				Earnings Calendar
			</Subtitle>

			<hr class="border-t border-slate-100" />
		</div>
		<!-- Loading state -->
		<div
			v-if="pending"
			class="flex justify-center py-8"
		>
			<div
				class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"
			></div>
		</div>

		<!-- Error state -->
		<div
			v-else-if="error"
			class="text-center py-8 text-slate-500"
		>
			<p class="text-sm">Unable to load earnings calendar</p>
		</div>

		<!-- Data -->
		<div v-else>
			<NuxtLink
				v-for="item in earnings"
				:key="item.symbol"
				:to="`/quote/${item.symbol}/`"
				class="flex items-center gap-4 hover:bg-slate-50 transition-colors duration-200 cursor-pointer w-full px-4"
			>
				<div class="flex w-full py-4 border-b border-slate-100 gap-3 items-center">
					<div class="flex flex-col items-center">
						<div class="bg-slate-50 rounded-lg px-3 py-3 w-14 h-14 text-center">
							<div class="text-xs font-semibold text-slate-500 leading-none">
								{{ item.month }}
							</div>
							<div class="text-xl font-bold text-slate-700 leading-none">
								{{ item.day }}
							</div>
						</div>
					</div>
					<div class="">
						<div
							class="font-medium text-base text-black line-clamp-1 mb-1 leading-none"
						>
							{{ item.company }}
						</div>
						<span class="text-slate-400 text-sm">{{ item.fullDate }}</span>
					</div>
				</div>
			</NuxtLink>
		</div>

		<ShowMore
			v-if="earnings.length > 3"
			class="mt-6"
			:class="{ relative: showAll }"
			:is-expanded="showAll"
			@click="toggleShowAll"
		/>
	</div>
</template>
<script setup>
const showAll = ref(false);

const containerRef = ref(null);

const toggleShowAll = () => {
	showAll.value = !showAll.value;

	// Scroll to top when collapsing
	if (!showAll.value && containerRef.value) {
		containerRef.value.scrollTop = 0;
	}
};

// Fetch earnings calendar data from API
const {
	data: earningsData,
	pending,
	error
} = await useFetch("/api/earnings-calendar");

// Transform the API data to component format
const earnings = computed(() => {
	if (!earningsData.value) {
		return [];
	}

	return earningsData.value.map((item) => {
		const date = new Date(item.date);
		const months = [
			"JAN",
			"FEB",
			"MAR",
			"APR",
			"MAY",
			"JUN",
			"JUL",
			"AUG",
			"SEP",
			"OCT",
			"NOV",
			"DEC"
		];
		const monthNames = [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December"
		];

		const month = months[date.getMonth()];
		const day = date.getDate().toString().padStart(2, "0");
		const fullDate = `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;

		return {
			month,
			day,
			company: item.companyName,
			fullDate,
			symbol: item.symbol
		};
	});
});
</script>
